/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import o from "react";
import { localeInfo as g } from "@progress/kendo-intl";
import { IntlProvider as u } from "../Intl/IntlProvider.mjs";
import { IntlDataProvider as P } from "../Intl/IntlDataProvider.mjs";
import { locales as m } from "../Intl/load.mjs";
import { LocalizationProvider as z } from "../Localization/LocalizationProvider.mjs";
import { LocalizationDataProvider as D } from "../Localization/LocalizationDataProvider.mjs";
import { messages as E } from "../Localization/messages.mjs";
import { useCustomComponent as i } from "@progress/kendo-react-common";
const G = (l) => {
  var r, a, n;
  const { language: t = "", locale: e = "en", children: c } = l, s = g(e), f = (r = E[t]) != null ? r : [], p = ((a = m.version) != null ? a : []).concat((n = m[s.name]) != null ? n : []), [d] = i(e ? u : o.Fragment), [v] = i(t ? z : o.Fragment);
  return /* @__PURE__ */ o.createElement(D, { data: f, language: t }, /* @__PURE__ */ o.createElement(P, { data: p, locale: e }, /* @__PURE__ */ o.createElement(v, { language: t }, /* @__PURE__ */ o.createElement(d, { locale: e }, c))));
};
export {
  G as ServerGlobalization
};
